
export interface IGetCmmAssetDto {
    description?: string | null
    drawingNumber?: string | null
    serialNumber?: string | null
    constructionYear?: number | null
}

export default class CmmAsset {
    description?: string
    drawingNumber?: string
    serialNumber?: string
    constructionYear?: number

    constructor(dto: IGetCmmAssetDto) {
        this.description = dto.description || undefined
        this.drawingNumber = dto.drawingNumber || undefined
        this.serialNumber = dto.serialNumber || undefined
        this.constructionYear = typeof dto.constructionYear === "number" ? dto.constructionYear : undefined
    }
}
